@if(chatbotEnabled) {
@if(!showChatbot) {
<div class="chatbot-btn">
    <div (mouseenter)="isHover = true" (mouseleave)="isHover = false" (click)="openChatbot()"
        class="flex gap-1 items-center m-0 pl-5 pr-0 rounded-[50px] transform transition-all duration-500"
        [ngClass]="{ 'bg-[linear-gradient(90deg,#6B96F1_0%,#16C5BC_100%)] shadow-[0_0_20px_0_rgba(0,255,233,0.20)]': isHover }">

        <p class="text-[#fff] text-sm font-semibold m-0 transform transition-all duration-500"
            [ngClass]="{ 'hidden': !isHover, 'inline-block': isHover }"> Ask Me Anything! </p>

        <img src="../assets/images/icon-chatbot.png" alt="Chatbot Icon"
            class="w-14 m-0 transform transition-all duration-500" />
    </div>
</div>
} @else {
<div class="chatbot-cross-btn">
    <div (click)="closeChatbot()" class="m-0">
        <img src="../assets/images/icon_cross.png" alt="cross Icon"
            class="w-14 m-0 transform transition-all duration-500 rounded-full bg-[linear-gradient(90deg,#6B96F1_0%,#16C5BC_100%)] p-4 " />
    </div>
</div>
}

@if(showChatbot) {
<div class="chatbot-backdrop" (click)="closeChatbot()">
    <div class="chatbot-overlay" (click)="$event.stopPropagation()">
        <div class="h-[402px]">
            <iframe [src]="chatbotUrl" class="chatbot_iframe" height="402px" frameborder="0"></iframe>
            <img src="../assets/images/icon_Sidebar.png" alt="Sidebar Icon">
        </div>
    </div>
</div>
}
}